<template>
<v-list-item >
  <v-list-item-content>
    <v-list-item-title>
      {{appt.title}}
      <v-chip v-if='appt.service_name' x-small v-text='appt.service_name' color='primary' outlined />
    </v-list-item-title>
    <v-list-item-subtitle>
      {{ appt.product_name }} with {{appt.practitioner_name}} @ {{appt.address_name}}
    </v-list-item-subtitle>
    <v-list-item-subtitle>
      {{ dateformat(appt.start_time, 'DATE_MED_WITH_WEEKDAY') }}.
      {{ dateformat(appt.start_time, 'TIME_24_SIMPLE') }} -
      {{ dateformat(appt.end_time, 'TIME_24_SIMPLE') }}
    </v-list-item-subtitle>
  </v-list-item-content>
  <slot name="list-item-action" ></slot>
</v-list-item>


</template>
<script>
export default {
  name: 'AppointmentListItem',
  props: {
    item: { type: Object, required: true }
  },
  computed: {
    appt () { return this.item }
  }
}
</script>
